<template>
  <v-container grid-list-md fluid class="pt-0 pb-0">
    <v-card class="pa-2 card-r">
      <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 text-white">
        <!--<router-link to="/"><v-icon class="text-white left pr-3">keyboard_arrow_left</v-icon></router-link>-->
        <div class="text-xs-left f-20">Block LIst</div>
      </v-toolbar>
    </v-card>
      <v-card class=" mt-2 no-shadow transparent">
      <v-layout row wrap class="">
        <v-flex lg6 sm6 xs12 class="">
          <v-card class="card-r no-shadow pa-2 grey lighten-4">
            <v-toolbar class="tow-clor-grey mb-2 card-r shadow-1 pl-3 text-white">
              <div class="text-xs-left f-20">Students</div>
            </v-toolbar>
            <v-list three-line class="pa-0 card-r transparent">
              <template v-for="(item, index) in BlockList">
                <v-subheader class="justify-center" v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
                <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"></v-divider>
                <v-list-tile class="shadow-1 card-r pa-0 white mt-2" v-else :key="item.title" avatar @click="">
                  <v-list-tile-avatar class="mt-1 mr-3" size="60"><img :src="item.image"></v-list-tile-avatar>
                  <v-list-tile-content class="f-12 pa-0">
                    <v-list-tile-title class="f-12" v-html="item.name"></v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary" v-html="item.email"></v-list-tile-sub-title>
                    <v-list-tile-sub-title class="f-12" v-html="item.blocked_reason"></v-list-tile-sub-title>
                  </v-list-tile-content>
                  <!-- <v-list-actions>
                    <v-btn v-show="!hidined" @click="hidined = true" class="card-r text-capitalize">Unblock</v-btn>
                    <v-btn v-show="hidined" @click="hidined = false" class="card-r text-capitalize">Undo</v-btn>
                  </v-list-actions> -->
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex lg6 sm6 xs12 class="">
          <v-card class="card-r no-shadow pa-2 grey lighten-4">
            <v-toolbar class="tow-clor-grey mb-2 card-r shadow-1 pl-3 text-white">
              <div class="text-xs-left f-20">Teachers</div>
            </v-toolbar>
            <v-list three-line class="pa-0 card-r transparent">
              <template v-for="(item, index) in TeacherBlockList">
                <v-subheader class="justify-center" v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
                <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"></v-divider>
                <v-list-tile class="shadow-1 card-r pa-0 white mt-2" v-else :key="item.name" avatar @click="">
                  <v-list-tile-avatar class="mt-1 mr-3" size="60"><img :src="item.image"></v-list-tile-avatar>
                  <v-list-tile-content class="f-12 pa-0">
                    <v-list-tile-title class="f-12" v-html="item.name"></v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary" v-html="item.email"></v-list-tile-sub-title>
                    <v-list-tile-sub-title class="f-12" v-html="item.blocked_reason"></v-list-tile-sub-title>
                  </v-list-tile-content>
                  <!-- <v-list-actions>
                    <v-btn v-show="!hidined" @click="hidined = true" class="card-r text-capitalize">Unblock</v-btn>
                    <v-btn v-show="hidined" @click="hidined = false" class="card-r text-capitalize">Undo</v-btn>
                  </v-list-actions> -->
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
      </v-card>
  </v-container>
</template>
<script>
  /* eslint-disable */
  import { mapState , dispatch } from "vuex"
  export default {
    data () {
      return {
        seen: true,
        hidined: false,
        items: [
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            avatar1: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            title1: 'student name',
            ttitle: 'teacher name',
            title: 'Not Booked',
            subtitle: "<span class='text--primary'>block DATE:10.12.2018 & TIME:11.10am </span> &mdash;this block reason or somthig..."
          }
        ],
      }
    },
        created:()=>{
        Store.dispatch('BlockList/getBlockList').then(res=>{
        })
        Store.dispatch('BlockList/getTeacherBlockList').then(res=>{
        })

    }
    ,computed:{
        ...mapState({
              BlockList:BlockList => Store.state.BlockList.BlockList,
              TeacherBlockList:TeacherBlockList => Store.state.BlockList.TeacherBlockList
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/BlockList.vue